import type { Transaction } from '../types'
import { TransactionStatus, TransactionType } from '../types'

export const DEFAULT_TRANSACTION = {
  account_guid: '',
  amount: 0,
  currency_code: '',
  date: 0,
  description: '',
  duplicate: false,
  feed_description: '',
  feed_status: TransactionStatus.POSTED,
  feed_transaction_date: 0,
  has_been_split: false,
  has_been_viewed: false,
  is_cleared: false,
  is_flagged: false,
  is_hidden: false,
  is_manual: true,
  is_personal: true,
  is_reimbursable: false,
  is_subscription: false,
  is_void: false,
  revision: 1,
  transaction_type: TransactionType.DEBIT,
  user_guid: '',
  is_duplicate: false,
  feed_transacted_at: 0,
  guid: '',
  memo: undefined,
  tags: [],
} as Transaction

export const COLUMN_NAMES = {
  FLAG: 'flag',
  DATE: 'date',
  PAYEE: 'payee',
  CATEGORY: 'category',
  ACCOUNT: 'account',
  AMOUNT: 'amount',
}
